import AbTesting from './AbTesting';
import Academy from './Academy';
import AiStar from './AiStar';
import Alerts from './Alerts';
import Analytics from './Analytics';
import AnchorLink from './AnchorLink';
import ApplePodcast from './ApplePodcast';
import ArrowDown from './ArrowDown';
import ArrowLeft from './ArrowLeft';
import ArrowNorthOutline from './ArrowNorthOutline';
import ArrowButtonRight from './ArrowButtonRight';
import AttributionReporting from './AttributionReporting';
import Automations from './Automations';
import AverageOrderValue from './AverageOrderValue';
import BackInStock from './BackInStock';
import Benchmarks from './Benchmarks';
import BranchOtherOutline from './BranchOtherOutline';
import Briefcase from './Briefcase';
import BrowsingHistory from './BrowsingHistory';
import Browsing from './Browsing';
import BugMarkFilled from './BugMarkFilled';
import BugMarkOutlined from './BugMarkOutlined';
import Calendar from './Calendar';
import Campaigns from './Campaigns';
import Cdp from './Cdp';
import CentralizedTexting from './CentralizedTexting';
import ChannelAffinity from './ChannelAffinity';
import CheckBullet from './CheckBullet';
import CheckMarkBullet from './CheckMarkBullet';
import CheckMark from './CheckMark';
import Check from './Check';
import ChevronDown from './ChevronDown';
import ChevronNorth from './ChevronNorth';
import ClockAndDelay from './ClockAndDelay';
import ClockOutline from './ClockOutline';
import Columns13 from './Columns13';
import Community from './Community';
import Compliance from './Compliance';
import ConditionalSplit from './ConditionalSplit';
import ConsentManagement from './ConsentManagement';
import ContactList from './ContactList';
import Contracts from './Contracts';
import Copy from './Copy';
import Coupons from './Coupons';
import CrossSell from './CrossSell';
import Cta from './Cta';
import CustomIntegrations from './CustomIntegrations';
import CustomerCommunicationHistory from './CustomerCommunicationHistory';
import CustomerHub from './CustomerHub';
import CustomerProfiles from './CustomerProfiles';
import DashOutline from './DashOutline';
import DataAutomations from './DataAutomations';
import Data from './Data';
import DatabaseAlt from './DatabaseAlt';
import Database from './Database';
import Demographic from './Demographic';
import Developers from './Developers';
import DragAndDropEmailBuilder from './DragAndDropEmailBuilder';
import Ecommerce from './Ecommerce';
import EmailAndSms from './EmailAndSms';
import Email from './Email';
import Events from './Events';
import Exit from './Exit';
import Expand from './Expand';
import Experiences from './Experiences';
import ExternalLink from './ExternalLink';
import Facebook from './Facebook';
import Featured from './Featured';
import Filter from './Filter';
import FitnessReimbursement from './FitnessReimbursement';
import Flows from './Flows';
import Forms from './Forms';
import FreeBookPolicy from './FreeBookPolicy';
import FullDataSync from './FullDataSync';
import Globe from './Globe';
import GooglePodcast from './GooglePodcast';
import HcLogoFr from './HcLogoFr';
import HeadspaceApp from './HeadspaceApp';
import HeartFilled from './HeartFilled';
import HeartOutlined from './HeartOutlined';
import HelpCenter from './HelpCenter';
import Images from './Images';
import InAppMessages from './InAppMessages';
import IncreasedCustomerLifetimeValue from './IncreasedCustomerLifetimeValue';
import InformationCircle from './InformationCircle';
import InformationFill from './InformationFill';
import InformationOutline from './InformationOutline';
import Instagram from './Instagram';
import IntegrationVideo from './IntegrationVideo';
import Integrations from './Integrations';
import KlaviyoFooterLogoDeDe from './KlaviyoFooterLogoDeDe';
import KlaviyoFooterLogoEnUs from './KlaviyoFooterLogoEnUs';
import KlaviyoFooterLogoEsEs from './KlaviyoFooterLogoEsEs';
import KlaviyoFooterLogoFrFr from './KlaviyoFooterLogoFrFr';
import KlaviyoFooterLogoItIt from './KlaviyoFooterLogoItIt';
import KlaviyoFooterLogo from './KlaviyoFooterLogo';
import KlaviyoLogoTaglineDeDe from './KlaviyoLogoTaglineDeDe';
import KlaviyoLogoTaglineEnUs from './KlaviyoLogoTaglineEnUs';
import KlaviyoLogoTaglineEsEs from './KlaviyoLogoTaglineEsEs';
import KlaviyoLogoTaglineFrFr from './KlaviyoLogoTaglineFrFr';
import KlaviyoLogoTaglineFrench from './KlaviyoLogoTaglineFrench';
import KlaviyoLogoTaglineItIt from './KlaviyoLogoTaglineItIt';
import KlaviyoLogoTaglineKoKr from './KlaviyoLogoTaglineKoKr';
import KlaviyoLogoTaglinePtBr from './KlaviyoLogoTaglinePtBr';
import KlaviyoLogoTagline from './KlaviyoLogoTagline';
import KlaviyoPodcast from './KlaviyoPodcast';
import KlaviyoPowerUpLogoDeDe from './KlaviyoPowerUpLogoDeDe';
import KlaviyoPowerUpLogoEnUs from './KlaviyoPowerUpLogoEnUs';
import KlaviyoPowerUpLogoEsEs from './KlaviyoPowerUpLogoEsEs';
import KlaviyoPowerUpLogoFrFr from './KlaviyoPowerUpLogoFrFr';
import KlaviyoPowerUpLogoFr from './KlaviyoPowerUpLogoFr';
import KlaviyoPowerUpLogoItIt from './KlaviyoPowerUpLogoItIt';
import KlaviyoPowerUpLogoKoKr from './KlaviyoPowerUpLogoKoKr';
import KlaviyoPowerUpLogoPtBr from './KlaviyoPowerUpLogoPtBr';
import KlaviyoPowerUpLogo from './KlaviyoPowerUpLogo';
import KlaviyoSwag from './KlaviyoSwag';
import LearningStipend from './LearningStipend';
import Learning from './Learning';
import LightningOutline from './LightningOutline';
import LinearAttribution from './LinearAttribution';
import LinkedIn from './LinkedIn';
import ListAutomations from './ListAutomations';
import List from './List';
import Logistics from './Logistics';
import LogoHelpCenter from './LogoHelpCenter';
import Logo from './Logo';
import LongArrowLeft from './LongArrowLeft';
import LongArrowRight from './LongArrowRight';
import Loyalty from './Loyalty';
import MailOutline from './MailOutline';
import MapMarker from './MapMarker';
import MenuDotsOutline from './MenuDotsOutline';
import MessageOutline from './MessageOutline';
import MinusCircle from './MinusCircle';
import MultiStepForm from './MultiStepForm';
import NavigationAi from './NavigationAi';
import NavigationCdp from './NavigationCdp';
import NavigationCustomerHub from './NavigationCustomerHub';
import NavigationEmail from './NavigationEmail';
import NavigationForms from './NavigationForms';
import NavigationMarketingAnalytics from './NavigationMarketingAnalytics';
import NavigationMobilePush from './NavigationMobilePush';
import NavigationRcs from './NavigationRcs';
import NavigationReviews from './NavigationReviews';
import NavigationSegmentation from './NavigationSegmentation';
import NavigationSms from './NavigationSms';
import NavigationTemplates from './NavigationTemplates';
import NavigationWhatsapp from './NavigationWhatsapp';
import NoCodingRequired from './NoCodingRequired';
import OmnichannelBuilder from './OmnichannelBuilder';
import OneClick from './OneClick';
import OrderConfirmation from './OrderConfirmation';
import Orders from './Orders';
import PeerComparison from './PeerComparison';
import Personalization from './Personalization';
import PlatformAlt from './PlatformAlt';
import Platform from './Platform';
import PlayCircleFilled from './PlayCircleFilled';
import PlayCircle from './PlayCircle';
import PlusCircleFilled from './PlusCircleFilled';
import PlusCircle from './PlusCircle';
import PlusOutline from './PlusOutline';
import PreBuiltTemplates from './PreBuiltTemplates';
import PredictiveAnalytics from './PredictiveAnalytics';
import PreferredMessaging from './PreferredMessaging';
import PriceDropper from './PriceDropper';
import Pricing from './Pricing';
import ProfileMerging from './ProfileMerging';
import PurchaseFrequency from './PurchaseFrequency';
import PurchaseRecovery from './PurchaseRecovery';
import PushNotifications from './PushNotifications';
import QuietHours from './QuietHours';
import QuoteInverted from './QuoteInverted';
import Quote from './Quote';
import Rcs from './Rcs';
import ReportsLibrary from './ReportsLibrary';
import Reports from './Reports';
import RetailPos from './RetailPos';
import Reviews from './Reviews';
import RssFeed from './RssFeed';
import ScheduledReports from './ScheduledReports';
import Search from './Search';
import Segmentation from './Segmentation';
import Shipping from './Shipping';
import ShopifyLogo from './ShopifyLogo';
import ShoppingCart from './ShoppingCart';
import ShoppingHistory from './ShoppingHistory';
import ShoppingPreference from './ShoppingPreference';
import SidebarRight from './SidebarRight';
import SmartSendTime from './SmartSendTime';
import SmsShortCode from './SmsShortCode';
import Sms from './Sms';
import SocialMediaMarketing from './SocialMediaMarketing';
import Spotify from './Spotify';
import SquareGridOutline from './SquareGridOutline';
import SubjectLineAssist from './SubjectLineAssist';
import Support from './Support';
import Surveys from './Surveys';
import TargetedCampaign from './TargetedCampaign';
import Templates from './Templates';
import Text from './Text';
import TheKlaviyoApproachDesktopLogo from './TheKlaviyoApproachDesktopLogo';
import TheKlaviyoApproachMobileLogo from './TheKlaviyoApproachMobileLogo';
import TimeDelay from './TimeDelay';
import Trigger from './Trigger';
import Twitter from './Twitter';
import TwoWayConversionSms from './TwoWayConversionSms';
import Upsell from './Upsell';
import Urls from './Urls';
import ValueAddedContent from './ValueAddedContent';
import Webhook from './Webhook';
import Welcome from './Welcome';
import Whatsapp from './Whatsapp';
import XMarkBullet from './XMarkBullet';
import X from './X';

export default {
  AbTesting,
  Academy,
  AiStar,
  Alerts,
  Analytics,
  AnchorLink,
  ApplePodcast,
  ArrowDown,
  ArrowLeft,
  ArrowNorthOutline,
  ArrowButtonRight,
  AttributionReporting,
  Automations,
  AverageOrderValue,
  BackInStock,
  Benchmarks,
  BranchOtherOutline,
  Briefcase,
  BrowsingHistory,
  Browsing,
  BugMarkFilled,
  BugMarkOutlined,
  Calendar,
  Campaigns,
  Cdp,
  CentralizedTexting,
  ChannelAffinity,
  CheckBullet,
  CheckMarkBullet,
  CheckMark,
  Check,
  ChevronDown,
  ChevronNorth,
  ClockAndDelay,
  ClockOutline,
  Columns13,
  Community,
  Compliance,
  ConditionalSplit,
  ConsentManagement,
  ContactList,
  Contracts,
  Copy,
  Coupons,
  CrossSell,
  Cta,
  CustomIntegrations,
  CustomerCommunicationHistory,
  CustomerHub,
  CustomerProfiles,
  DashOutline,
  DataAutomations,
  Data,
  DatabaseAlt,
  Database,
  Demographic,
  Developers,
  DragAndDropEmailBuilder,
  Ecommerce,
  EmailAndSms,
  Email,
  Events,
  Exit,
  Expand,
  Experiences,
  ExternalLink,
  Facebook,
  Featured,
  Filter,
  FitnessReimbursement,
  Flows,
  Forms,
  FreeBookPolicy,
  FullDataSync,
  Globe,
  GooglePodcast,
  HcLogoFr,
  HeadspaceApp,
  HeartFilled,
  HeartOutlined,
  HelpCenter,
  Images,
  InAppMessages,
  IncreasedCustomerLifetimeValue,
  InformationCircle,
  InformationFill,
  InformationOutline,
  Instagram,
  IntegrationVideo,
  Integrations,
  KlaviyoFooterLogoDeDe,
  KlaviyoFooterLogoEnUs,
  KlaviyoFooterLogoEsEs,
  KlaviyoFooterLogoFrFr,
  KlaviyoFooterLogoItIt,
  KlaviyoFooterLogo,
  KlaviyoLogoTaglineDeDe,
  KlaviyoLogoTaglineEnUs,
  KlaviyoLogoTaglineEsEs,
  KlaviyoLogoTaglineFrFr,
  KlaviyoLogoTaglineFrench,
  KlaviyoLogoTaglineItIt,
  KlaviyoLogoTaglineKoKr,
  KlaviyoLogoTaglinePtBr,
  KlaviyoLogoTagline,
  KlaviyoPodcast,
  KlaviyoPowerUpLogoDeDe,
  KlaviyoPowerUpLogoEnUs,
  KlaviyoPowerUpLogoEsEs,
  KlaviyoPowerUpLogoFrFr,
  KlaviyoPowerUpLogoFr,
  KlaviyoPowerUpLogoItIt,
  KlaviyoPowerUpLogoKoKr,
  KlaviyoPowerUpLogoPtBr,
  KlaviyoPowerUpLogo,
  KlaviyoSwag,
  LearningStipend,
  Learning,
  LightningOutline,
  LinearAttribution,
  LinkedIn,
  ListAutomations,
  List,
  Logistics,
  LogoHelpCenter,
  Logo,
  LongArrowLeft,
  LongArrowRight,
  Loyalty,
  MailOutline,
  MapMarker,
  MenuDotsOutline,
  MessageOutline,
  MinusCircle,
  MultiStepForm,
  NavigationAi,
  NavigationCdp,
  NavigationCustomerHub,
  NavigationEmail,
  NavigationForms,
  NavigationMarketingAnalytics,
  NavigationMobilePush,
  NavigationRcs,
  NavigationReviews,
  NavigationSegmentation,
  NavigationSms,
  NavigationTemplates,
  NavigationWhatsapp,
  NoCodingRequired,
  OmnichannelBuilder,
  OneClick,
  OrderConfirmation,
  Orders,
  PeerComparison,
  Personalization,
  PlatformAlt,
  Platform,
  PlayCircleFilled,
  PlayCircle,
  PlusCircleFilled,
  PlusCircle,
  PlusOutline,
  PreBuiltTemplates,
  PredictiveAnalytics,
  PreferredMessaging,
  PriceDropper,
  Pricing,
  ProfileMerging,
  PurchaseFrequency,
  PurchaseRecovery,
  PushNotifications,
  QuietHours,
  QuoteInverted,
  Quote,
  Rcs,
  ReportsLibrary,
  Reports,
  RetailPos,
  Reviews,
  RssFeed,
  ScheduledReports,
  Search,
  Segmentation,
  Shipping,
  ShopifyLogo,
  ShoppingCart,
  ShoppingHistory,
  ShoppingPreference,
  SidebarRight,
  SmartSendTime,
  SmsShortCode,
  Sms,
  SocialMediaMarketing,
  Spotify,
  SquareGridOutline,
  SubjectLineAssist,
  Support,
  Surveys,
  TargetedCampaign,
  Templates,
  Text,
  TheKlaviyoApproachDesktopLogo,
  TheKlaviyoApproachMobileLogo,
  TimeDelay,
  Trigger,
  Twitter,
  TwoWayConversionSms,
  Upsell,
  Urls,
  ValueAddedContent,
  Webhook,
  Welcome,
  Whatsapp,
  XMarkBullet,
  X,
};
